import Box from 'components/ui/box';
import { IoMdCloseCircle } from 'react-icons/io';

interface Props {
  onClose: (clear?: boolean) => void;
}

export default function Modal({ onClose }: Props) {
  return (
    <div className="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center">
      <Box className="relative bg-oxford-blue border-electric-blue p-1 lg:p-8 flex flex-col w-[90%] lg:w-auto lg:max-w-[600px] justify-center items-center border-opacity-100 bg-opacity-100">
        <button className="absolute -top-5 -right-5 button-close" onClick={() => onClose(true)}>
          <IoMdCloseCircle size={48} className="text-slate-blue" />
        </button>

        <div className="text-center space-y-3">
          <h1 className="text-yellow text-center text-lg mb-4">Ops!</h1>

          <p>Essa pessoa possui relacionamento cadastrado com você. Deseja mesmo prosseguir?</p>

          <div className="pt-5">
            <button
              className={`pt-5text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none`}
              onClick={() => {
                onClose();
              }}
            >
              CONFIRMAR
            </button>
          </div>
        </div>
      </Box>
    </div>
  );
}
